import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, ArrowLeft } from "lucide-react";
import { EISG } from "@/constants/testIds";
import EISGLogo from "@/components/shared/EISGLogo";

const links = [
  { to: "/eisg", label: "Accueil", end: true },
  { to: "/eisg/about", label: "À propos" },
  { to: "/eisg/programmes", label: "Programmes" },
  { to: "/eisg/cohorts", label: "Cohortes" },
  { to: "/eisg/advisory", label: "Advisory & In-House" },
  { to: "/eisg/experience", label: "Experience" },
  { to: "/eisg/investment", label: "Investment" },
  { to: "/eisg/registration", label: "Registration" },
  { to: "/eisg/contact", label: "Contact" },
];

const EISGNavbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid={EISG.nav}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A192F]/95 backdrop-blur-xl border-b border-white/10" : "bg-[#0A192F]/85 backdrop-blur-md"
      } text-white`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-24 sm:h-28 flex items-center justify-between">
        <Link to="/eisg" data-testid={EISG.navLogo} className="flex items-center group">
          <EISGLogo variant="compact" tone="light" />
        </Link>

        <nav className="hidden xl:flex items-center gap-6">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `text-[12.5px] tracking-wide font-medium transition-colors ${
                  isActive ? "text-[#D4AF37]" : "text-white/75 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/"
            data-testid={EISG.navBackBd}
            className="inline-flex items-center gap-1.5 text-[12px] font-semibold border border-white/30 px-3 py-1.5 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
          >
            <ArrowLeft size={13} /> BridgeDatum
          </Link>
        </nav>

        <button
          data-testid={EISG.navMobileToggle}
          onClick={() => setOpen((o) => !o)}
          className="xl:hidden p-2 text-white"
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden border-t border-white/10 bg-[#0A192F]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-sm font-medium ${isActive ? "text-[#D4AF37]" : "text-white/80"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/" onClick={() => setOpen(false)} className="text-sm font-semibold text-white/90 inline-flex items-center gap-2">
              <ArrowLeft size={14} /> Back to BridgeDatum
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default EISGNavbar;
